var _defs, _rect, _rect2, _circle, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _polyline, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSsmErpCover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 500,
    viewBox: "0 0 800 500",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg1",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0f2027"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "#203a43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#2c5364"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "accent1",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#2dd4bf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#22c55e"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 500,
    fill: "url(#bg1)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 800,
    height: 56,
    fill: "#0b1720"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 28,
    r: 8,
    fill: "#2dd4bf"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 20,
    width: 160,
    height: 16,
    rx: 4,
    fill: "#3a5460"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 640,
    y: 16,
    width: 120,
    height: 24,
    rx: 12,
    fill: "#12242c"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 56,
    width: 180,
    height: 444,
    fill: "#0c1e26"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 90,
    width: 132,
    height: 14,
    rx: 4,
    fill: "url(#accent1)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 130,
    width: 110,
    height: 10,
    rx: 3,
    fill: "#3a5460"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 160,
    width: 110,
    height: 10,
    rx: 3,
    fill: "#3a5460"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 190,
    width: 110,
    height: 10,
    rx: 3,
    fill: "#3a5460"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 220,
    width: 110,
    height: 10,
    rx: 3,
    fill: "#3a5460"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 250,
    width: 110,
    height: 10,
    rx: 3,
    fill: "#3a5460"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 86,
    width: 170,
    height: 90,
    rx: 10,
    fill: "#123844"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 230,
    y: 104,
    width: 90,
    height: 10,
    rx: 3,
    fill: "#8fe3d1"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 230,
    y: 128,
    width: 60,
    height: 20,
    rx: 4,
    fill: "#2dd4bf"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 398,
    y: 86,
    width: 170,
    height: 90,
    rx: 10,
    fill: "#123844"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 418,
    y: 104,
    width: 90,
    height: 10,
    rx: 3,
    fill: "#8fe3d1"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 418,
    y: 128,
    width: 60,
    height: 20,
    rx: 4,
    fill: "#22c55e"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 586,
    y: 86,
    width: 170,
    height: 90,
    rx: 10,
    fill: "#123844"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 606,
    y: 104,
    width: 90,
    height: 10,
    rx: 3,
    fill: "#8fe3d1"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 606,
    y: 128,
    width: 60,
    height: 20,
    rx: 4,
    fill: "#facc15"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 196,
    width: 360,
    height: 230,
    rx: 12,
    fill: "#0f2b34"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "230,380 270,340 310,360 350,300 390,320 430,260 470,290 510,230 540,250",
    fill: "none",
    stroke: "#2dd4bf",
    strokeWidth: 4
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 586,
    y: 196,
    width: 170,
    height: 230,
    rx: 12,
    fill: "#0f2b34"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 600,
    y: 212,
    width: 140,
    height: 10,
    rx: 3,
    fill: "#3a5460"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 600,
    y: 234,
    width: 140,
    height: 10,
    rx: 3,
    fill: "#2b4a55"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 600,
    y: 256,
    width: 140,
    height: 10,
    rx: 3,
    fill: "#3a5460"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 600,
    y: 278,
    width: 140,
    height: 10,
    rx: 3,
    fill: "#2b4a55"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 600,
    y: 300,
    width: 140,
    height: 10,
    rx: 3,
    fill: "#3a5460"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 230,
    y: 470,
    fontFamily: "Arial, sans-serif",
    fontSize: 26,
    fill: "#e6fbf7",
    fontWeight: "bold"
  }, "Super Shine ERP")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSsmErpCover);
export default __webpack_public_path__ + "static/media/ssm-erp-cover.04eb3a817af78ad2d2bf059ffe66eab4.svg";
export { ForwardRef as ReactComponent };